export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-de.7d51247e.svg";